import { AddressCapture } from './address-capture'
import type { ResolvedAddress } from '@/admin/hooks/use-lookups'

interface Props {
  address: ResolvedAddress | null
  onChange: (next: ResolvedAddress | null) => void
  error?: string
  'data-testid'?: string
  lookupProvider?: string
  /** Notified with unresolved search text (see AddressCapture.onPendingChange). */
  onPendingChange?: (pendingTerm: string) => void
}

export function MailingAddressCapture({ address, onChange, error, 'data-testid': testId, lookupProvider, onPendingChange }: Props) {
  return (
    <AddressCapture
      value={address}
      onChange={onChange}
      error={error}
      searchInputName="mailing-address-search"
      testId={testId}
      summaryLabel=""
      enterManualLabel="Enter address manually"
      enterTitle="Enter mailing address"
      editTitle="Edit mailing address"
      lookupProvider={lookupProvider}
      onPendingChange={onPendingChange}
    />
  )
}
